import { Route, Routes } from "react-router-dom";
import Tests from "./Tests";

export default function TestsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Tests />} />
    </Routes>
  );
}
